import DiscussionMessagesComponent from './DiscussionMessagesComponent';

export default DiscussionMessagesComponent;
